import type { RegistryEntry } from '../types';

// Wavespeed 系列
export const wavespeedConfigs: Record<string, RegistryEntry> = {
  // Wavespeed Qwen LoRA：提供三个 LoRA 路径输入，组装到 providerOptions 根级
  'wavespeed-ai/qwen-image/text-to-image-lora': {
    options: [
      { key: 'loras1', label: 'LoRA 1 Path', type: 'input', default: '', group: 'basic' },
      { key: 'loras1_scale', label: 'LoRA 1 Scale', type: 'slider', min: 0, max: 4, step: 0.01, default: 1, group: 'basic' },
      { key: 'loras2', label: 'LoRA 2 Path', type: 'input', default: '', group: 'basic' },
      { key: 'loras2_scale', label: 'LoRA 2 Scale', type: 'slider', min: 0, max: 4, step: 0.01, default: 1, group: 'basic' },
      { key: 'loras3', label: 'LoRA 3 Path', type: 'input', default: '', group: 'basic' },
      { key: 'loras3_scale', label: 'LoRA 3 Scale', type: 'slider', min: 0, max: 4, step: 0.01, default: 1, group: 'basic' },
    ],
    toProviderOptions: (ui) => ({
      loras1: (() => {
        const path = typeof ui.loras1 === 'string' ? ui.loras1.trim() : '';
        if (!path) return undefined;
        const raw = typeof ui.loras1_scale === 'number' ? ui.loras1_scale : 1;
        const scale = Math.max(0, Math.min(4, Number.isFinite(raw) ? raw : 1));
        return { path, scale };
      })(),
      loras2: (() => {
        const path = typeof ui.loras2 === 'string' ? ui.loras2.trim() : '';
        if (!path) return undefined;
        const raw = typeof ui.loras2_scale === 'number' ? ui.loras2_scale : 1;
        const scale = Math.max(0, Math.min(4, Number.isFinite(raw) ? raw : 1));
        return { path, scale };
      })(),
      loras3: (() => {
        const path = typeof ui.loras3 === 'string' ? ui.loras3.trim() : '';
        if (!path) return undefined;
        const raw = typeof ui.loras3_scale === 'number' ? ui.loras3_scale : 1;
        const scale = Math.max(0, Math.min(4, Number.isFinite(raw) ? raw : 1));
        return { path, scale };
      })(),
    } as unknown as Record<string, Record<string, any>>),
  },

  // Wavespeed 图像模型：支持目标分辨率
  'wavespeed-ai/seedvr2/image': {
    options: [
      {
        key: 'target_resolution',
        label: 'Target Resolution',
        type: 'select',
        options: [
          { label: '2K', value: '2k' },
          { label: '4K', value: '4k' },
          { label: '8K', value: '8k' },
        ],
        default: '4k',
        group: 'advanced',
      },
    ],
    toProviderOptions: (ui) => ({
      wavespeed: {
        target_resolution: typeof ui.target_resolution === 'string' ? ui.target_resolution : '4k',
      },
    }),
  },
};
